<div class="tool-installation-container">
  <h1>Tool installation assistant</h1>
  <p>
    Upload the tool you wish to add to Hephaestus. To update an existing tool, upload the new
    version here as well. Please ensure that you increment the version number when submitting an
    update. The tool must be packaged as a .zip file following the predefined tool structure.
  </p>
  <div class="content-container">
    @if (isUploadSuccessful()) {
      <mat-icon color="primary">download_done</mat-icon>
    } @else {
      <app-file-upload
        class="upload-field"
        (fileSelectedEvent)="onFileSelect($event)"
        [inputDetails]="{
          displayName: 'Tool',
          description: 'Upload here a tool as zip',
        }"
        [isList]="false"
        [supportedMediaTypes]="['application/zip']">
      </app-file-upload>
    }
  </div>
  @if (!isUploadSuccessful() && isUploadStarted()) {
    <mat-error> Something went wrong while tool upload. See logs for further details. </mat-error>
  }
  @if (isUploadSuccessful() && isUploadStarted()) {
    <p>
      The tool was successfully uploaded. Installation will now begin. For more details, check the
      specific tool's settings.
    </p>
  }
  <div class="action-buttons">
    <button mat-raised-button (click)="installTool()" [disabled]="!selectedFile()" color="primary">
      Start installation
    </button>
    <button mat-raised-button (click)="openLogs()" [disabled]="!logs()" color="secondary">
      Show logs
    </button>
  </div>
</div>
<app-spinner></app-spinner>
